import IContactNotification from "@myinnsworth/models/contact/IContactNotification";
import { useCallback, useEffect, useState } from "react";
import { contactHttpService } from "@myinnsworth/httpServices";
import NotificationsListGroup from "./notificationListGroup";
import { isAfter, isBefore, isToday, subDays } from "date-fns";

export interface INotificationsListProps {
    newNotificationCount?: number;
    visible: boolean;
    onClose: () => void;
    onSetHasUnreadNotifications: (hasUnreadNotifications: boolean) => void;
}

export default function NotificationsList(props: INotificationsListProps) {
    const [notificationsToday, setNotificationsToday] = useState<Array<IContactNotification>>([]);
    const [notifications7Days, setNotifications7Days] = useState<Array<IContactNotification>>([]);
    const [notificationsOlder, setNotificationsOlder] = useState<Array<IContactNotification>>([]);

    const searchNotifications = useCallback(async () => {
        try {
            const results = await contactHttpService.searchNotifications({});
            const todaysNotifications = new Array<IContactNotification>();
            const lastWeeksNotifications = new Array<IContactNotification>();
            const olderNotifications = new Array<IContactNotification>();
            const now = new Date();
            const lastWeek = subDays(now, 7);

            results.results.forEach(notification => {
                if(isToday(notification.created)) {
                    todaysNotifications.push(notification);
                } else if(isBefore(notification.created, now) && isAfter(notification.created, lastWeek)) {
                    lastWeeksNotifications.push(notification);
                } else {
                    olderNotifications.push(notification);
                }
            });

            setNotificationsToday(todaysNotifications);
            setNotifications7Days(lastWeeksNotifications);
            setNotificationsOlder(olderNotifications);
        } catch {}
    }, []);

    useEffect(() => {
        searchNotifications();
    }, [searchNotifications]);

    return (
        <>
        {props.visible && (
            <div className="notifications-list" >
            <div className="notifications-header">
                <h6>Notifications { props.newNotificationCount && (<>{`(${props.newNotificationCount!})`}</>) }</h6>
                <button title="Toggle Notifications" onClick={() => props.onClose()}>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 13L13 1M1 1L13 13" stroke="#262824" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div className="notifications-body">
                {notificationsToday.length > 0 && (<NotificationsListGroup title="Today" notifications={notificationsToday} />)}
                {notifications7Days.length > 0 && (<NotificationsListGroup title="Last 7 days" notifications={notifications7Days} />)}
                {notificationsOlder.length > 0 && (<NotificationsListGroup title="Older" notifications={notificationsOlder} />)}
                {(notificationsToday.length === 0 && notifications7Days.length === 0 && notificationsOlder.length === 0) && <>
                    <div style={{marginLeft: '16px', paddingBottom: '10px'}}>No Notifications</div>
                </> }
            </div>
        </div>
        )}
    </>);
}